import API from '../../../../services/API';

export const surveySupportMeasures = (data) => {
  return API.request({
    url: '/surveySupportMeasures',
    method: 'POST',
    data,
  });
};
export const surveySupportMeasuresDicts = () => {
  return API.request({
    url: '/surveySupportMeasures/dicts',
    method: 'GET',
  });
};
